import { PropsWithChildren } from 'react';
import Icon from '@mdi/react';
import { mdiAlertCircleOutline, mdiCheckCircleOutline, mdiInformationOutline } from '@mdi/js';
import { twMerge } from 'tailwind-merge';

interface IAlertBoxProps extends PropsWithChildren {
    theme: 'success' | 'info' | 'warning' | 'danger' | 'light' | 'primary';
    heading?: string;
    className?: string;
    containerCss?: string;
    hideIcon?: boolean;
}

const AlertBox = ({ className, containerCss, heading, theme, hideIcon, children }: IAlertBoxProps) => {
    const getIcon = (theme: string) => {
        switch (theme) {
            case 'success':
                return mdiCheckCircleOutline;
            case 'info':
                return mdiInformationOutline;
            default:
                return mdiAlertCircleOutline;
        }
    };

    return (
        <div
            className={twMerge(`alert alert-${theme} mb-0`, className)}
            role='alert'
        >
            <div className={containerCss}>
                <div className='d-flex flex-wrap gap-2'>
                    {!hideIcon ? (
                        <Icon
                            path={getIcon(theme)}
                            className='mdi'
                        />
                    ) : null}
                    <div className='d-flex flex-wrap flex-column  flex-1'>
                        {heading ? <h5 className='alert-heading'>{heading}</h5> : null}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertBox;
